module.exports = __webpack_public_path__ + "img/blog6-logo-7.919562f8.webp";